import { PlusIcon } from 'lucide-react';

import { CommandItem } from '@/components/ui/command';
import type { ComboboxOption } from './combobox-list';

// "Add '<typed>'" row — shown only when the query matches no existing option.
export function CreateItem({
  query,
  options,
  onCreate,
}: Readonly<{
  query: string;
  options: readonly ComboboxOption[];
  onCreate: (label: string) => void;
}>) {
  const trimmed = query.trim();
  if (trimmed.length === 0) return null;
  const lower = trimmed.toLowerCase();
  const exists = options.some(
    (o) => o.value.toLowerCase() === lower || o.label.toLowerCase() === lower,
  );
  if (exists) return null;
  return (
    <CommandItem
      value={`__create__${trimmed}`}
      forceMount
      onSelect={() => {
        onCreate(trimmed);
      }}
    >
      <PlusIcon className="size-4" aria-hidden />
      Add “{trimmed}”
    </CommandItem>
  );
}
